export default __webpack_public_path__ + "images/ACK.3d45c13.png";